/* eslint-disable @typescript-eslint/camelcase */

import React, { useState, useContext, useRef } from 'react';
import memoizee from 'memoizee';
import { useSnackbar } from 'notistack';
import useTranslate from './useTranslate';
import loadScript from 'utils/loadScript';

const startIovation: () => Promise<string> = memoizee(() => {
  return new Promise((resolve, reject) => {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const anyWindow = window as any;
    anyWindow.io_global_object_name = 'IGLOO';
    anyWindow.IGLOO = anyWindow.IGLOO || {
      loader: {
        version: '5.2.2',
        uri_hook: '/iovation',
      },
      bb_callback: (blackbox: string, completed: unknown) => {
        if (completed) {
          resolve(blackbox);
        }
      },
    };
    loadScript(`${process.env.PUBLIC_URL}/iovationLoader.js`).catch(_ =>
      reject('iovation error'),
    );
  });
});

export const IovationContext = React.createContext<Promise<string> | null>(
  null,
);

const useIovation: () => Promise<string> | null = () => {
  return useContext(IovationContext);
};

/**
 * Set up the Iovation script.
 *
 * Use this high up (preferably in the top level App component ) so that it
 * can be triggered early.
 */
const IovationProvider: React.FC = ({ children }) => {
  const { enqueueSnackbar } = useSnackbar();
  const t = useTranslate();
  const [promise] = useState<Promise<string>>(startIovation());
  const errorCatchingSetup = useRef<boolean>(false);
  if (!errorCatchingSetup.current) {
    promise.catch(_ => {
      enqueueSnackbar(t('iovation.adblockError'), {
        variant: 'error',
        persist: true,
      });
    });
    errorCatchingSetup.current = true;
  }
  return (
    <IovationContext.Provider value={promise}>
      {children}
    </IovationContext.Provider>
  );
};

export { IovationProvider };

export default useIovation;
